import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from './auth.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit{
  constructor(public authService: AuthService, private router: Router) {}

  ngOnInit(){

  }

  canSeeOrgUsers() {
    // TODO: move the actual scope to the auth service scope dictionary?
    return this.authService.hasScope("iam:read:user_organization");
  }
  
  title = 'moya-iam';
}
